<div #viewport class="horizontal-messages-container">
  <div #messagesWrapper class="messages-wrapper">
    @for (message of displayMessages(); track trackByMessageId($index, message)) {
      <div class="message-item">
        <span class="username">
          <img class="platform-icon"
               [src]="message.platform === 'youtube' ? '/assets/icons/youtube-without-bg.svg' : '/assets/icons/twitch-without-bg.svg'"
               alt="" />
          <span>{{ message.username || 'Unknown' }}</span>
        </span>
        <span class="message-text">{{ message.message || '' }}</span>
      </div>
    }
  </div>
</div>
